/* Selector de compra de la ficha (snippets/gw-selector.liquid) — Genwell, 8-oct-2026.
   v2 (Leo, misma noche: «no se sabe dónde dar clic, si está seleccionado o ya está agregado»):
   cada opción es un renglón con su círculo — 1 · 2 · 3 del mismo producto (por días o
   noches) y debajo los kits que ya existen, con su precio de kit — y aparte, compra única
   o suscripción, con sus razones a la vista. Un solo /cart/add.js y abre el cajón.
   v3 (Leo, 12-oct): 1 · 2 · 3 en tarjetas con la foto repetida (2 meses = 2 frascos) y el
   kit se suma a lo elegido: con 2 meses son 2 kits y su plan de 60 días; nunca baja el pedido.
   v4 (Leo, 12-oct: «que ellos elijan la cantidad del complemento»): cada complemento con su
   − n +; el pedido se arma solo al precio más bajo (parejas como kit, o suelto con el % de 3). */
(function () {
  if (window.customElements.get('gw-selector')) return;

  var MES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  function m(c) { return '$' + Math.round(c / 100).toLocaleString('en-US'); }
  // Ahorro = resta de los precios ya redondeados que se ven ($5,097 − $4,842 = $255)
  function resta(a, b) { return m(Math.round(a / 100) * 100 - Math.round(b / 100) * 100); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (x) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[x]; }); }
  // Complemento con sabor: «Proteína Vegana · Cacao»
  function nomC(p) { return corto(p.t) + (p.op ? ' · ' + p.op : ''); }
  function corto(t) { var r = String(t).replace(/\s+360\b/, '').replace(/\s+Premium\b/, ''); return r.length > 3 ? r : String(t); }
  function hasta(dias) { var d = new Date(); d.setDate(d.getDate() + dias); return d.getDate() + ' de ' + MES[d.getMonth()]; }
  function cadaDias(plan) { var r = plan && /(\d+)/.exec(plan.n || ''); return r ? r[1] : ''; }
  // q piezas iguales = el plan q (2 bolsas → «Cada 80 días»); un kit va con el primero.
  function planDe(p, q) {
    if (!p || !p.plan) return null;
    var ids = p.plan.ids || [p.plan.id], ns = p.plan.ns || [p.plan.n], i = Math.min(Math.max(q, 1), ids.length) - 1;
    return { id: ids[i], n: ns[i] };
  }
  var RADIO = '<span class="gw-sel__radio" aria-hidden="true"></span>';

  class GwSelector extends HTMLElement {
    connectedCallback() {
      if (this._listo) return;
      var raw = this.querySelector('.gw-sel__data');
      if (!raw) return;
      try { this.d = JSON.parse(raw.textContent); } catch (e) { return; }
      if (!this.d.main || !this.d.main.ok) return; // agotado: se queda el botón del tema
      this._listo = true;
      var self = this, d = this.d, c = d.cfg;
      this.kits = (d.kits || []).filter(function (k) {
        return k.k && k.k.ok && (k.con || []).length;
      }).map(function (k) { return { kit: k.k, con: k.con }; });
      // Complementos: cada producto que va en un kit con este, una sola vez; si hay kit de
      // a dos, se guarda para cobrar las parejas a precio de kit. El cliente elige la cantidad.
      var vistos = {};
      this.comp = [];
      // Por variante (Roberto, 19-oct: la Vegana con cada sabor en su renglón); un kit cae en su primera variante
      var deProd = {};
      function suma(p, deKit) {
        if (!p || !p.ok || vistos[p.v] || (deKit && deProd[p.id])) return;
        vistos[p.v] = { prod: p, kit: null, m: 0 };
        deProd[p.id] = deProd[p.id] || vistos[p.v];
        self.comp.push(vistos[p.v]);
      }
      // Leo, 12-oct: los más vendidos primero (Proteína Real, Creatina, Omega…); si la ficha no trae lista, los de sus kits
      (d.comps && d.comps.length ? d.comps : []).forEach(function (p) { suma(p); });
      this.kits.forEach(function (k) { k.con.forEach(function (p) { suma(p, true); }); });
      // Si hay kit de a dos con el complemento, las parejas se cobran a precio de kit
      this.kits.forEach(function (k) {
        var x = k.con.length === 1 && deProd[k.con[0].id];
        if (x && !x.kit) x.kit = k.kit;
      });
      // La ventana «Ver otro suplemento» (fuera del bloque: <dialog> modal)
      if (this.comp.length > 3) {
        this.dlg = document.createElement('dialog');
        this.dlg.className = 'gw-sel__dlg';
        this.dlg.setAttribute('aria-label', c.tMas || 'Otros suplementos');
        document.body.appendChild(this.dlg);
        this.dlg.addEventListener('click', function (e) { if (e.target === self.dlg) self.dlg.close(); else self.onClick(e); });
      }
      // Roberto, 13-oct: en los kits (cantidades = false) va 1 kit fijo y solo se suman complementos
      this.n = c.cantidades === false ? 1 : Math.min(3, Math.max(1, Number(c.marcada) || 1));
      this.sub = !!(c.subMarcada && d.main.plan);
      this.pi = null; // Roberto, 19-oct: plan elegido a mano (0 · 1 · 2); null = el que va con la cantidad
      this.addEventListener('click', this.onClick.bind(this));
      // 15-oct (Leo): si la ficha trae el bloque «Complementos (GW)», los complementos van ahí (debajo de pagos y envío)
      var info = this.closest('.product__info-container, .product__info-wrapper, product-info, section');
      this.compsSlot = info ? info.querySelector('.gw-sel__comps--slot') : null;
      if (this.compsSlot) this.compsSlot.addEventListener('click', this.onClick.bind(this));
      this.fija = document.getElementById('GwSelFija-' + this.dataset.block);
      if (this.fija) {
        document.body.appendChild(this.fija); // fuera de cualquier contenedor con transform
        this.fija.addEventListener('click', function (e) { if (e.target.closest('[data-gw-add]')) self.agregar(); });
      }
      // Productos con sabores (Vegana): el selector sigue a la variante que se elige arriba
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
          var v = ev && ev.data && ev.data.variant;
          if (!v || !v.id) return;
          d.main.v = v.id; d.main.p = v.price; d.main.a = v.compare_at_price || 0; d.main.ok = !!v.available;
          var src = v.featured_image && v.featured_image.src;
          if (src) d.main.img = src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=240';
          // 15-oct: la barra fija también cambia de foto con el sabor (se quedaba en Cacao)
          if (src && self.fija && self.fija.querySelector('img')) self.fija.querySelector('img').src = d.main.img;
          self.pintar();
        });
      }
      this.pintar();
      this.classList.add('is-listo');
      document.documentElement.classList.add('gw-sel-on');
      this.observar();
    }

    /* ---------- cuentas ---------- */
    // Solo el producto: lo que dice cada tarjeta 1 · 2 · 3.
    cuenta(n) {
      var c = this.d.cfg, main = this.d.main, base = n * main.p;
      var precio = base * (1 - (n >= 3 ? Number(c.pct3) || 0 : 0) / 100);
      var envio = n < (Number(c.umbral) || 2) ? (Number(c.envio) || 0) * 100 : 0;
      return { base: base, precio: precio, envio: envio };
    }
    // Precio de un pedido: los kits a su precio; lo suelto, con el % de 3 piezas si junta 3
    // (lo cobra el descuento automático de Shopify, que no cuenta los kits).
    costear(o) {
      var c = this.d.cfg, sueltas = 0, suelto = 0, kits = 0, base = 0, hayKit = false;
      o.lineas.forEach(function (l) {
        if (l.kit) { kits += l.q * l.prod.p; base += l.q * Math.max(l.prod.a || 0, l.prod.p); hayKit = true; }
        else { sueltas += l.q; suelto += l.q * l.prod.p; base += l.q * l.prod.p; }
      });
      o.precio = kits + suelto * (1 - (sueltas >= 3 ? Number(c.pct3) || 0 : 0) / 100);
      o.base = base;
      o.envio = !hayKit && sueltas < (Number(c.umbral) || 2) ? (Number(c.envio) || 0) * 100 : 0;
      return o;
    }
    // El pedido más barato para el cliente con lo que eligió: todo suelto, o las parejas
    // producto + complemento como kit (el de más ahorro primero). Nunca cobra de más.
    pedido() {
      var main = this.d.main, n = this.n, sel = this.comp.filter(function (x) { return x.m > 0; });
      var esKit = main.a > main.p; // ficha de un kit
      var A = { lineas: [{ prod: main, q: n, kit: esKit }].concat(sel.map(function (x) { return { prod: x.prod, q: x.m }; })) };
      var libres = n, B = { lineas: [] }, conKit = false;
      sel.slice().sort(function (a, b) { return (b.kit ? b.kit.a - b.kit.p : 0) - (a.kit ? a.kit.a - a.kit.p : 0); }).forEach(function (x) {
        var pares = x.kit ? Math.min(libres, x.m) : 0;
        if (pares) { B.lineas.push({ prod: x.kit, q: pares, kit: true }); libres -= pares; conKit = true; }
        if (x.m > pares) B.lineas.push({ prod: x.prod, q: x.m - pares });
      });
      if (libres) B.lineas.unshift({ prod: main, q: libres, kit: esKit });
      this.costear(A);
      if (!conKit) return A;
      this.costear(B);
      return B.precio + B.envio < A.precio + A.envio ? B : A;
    }
    // Plan de la suscripción: el elegido a mano, o el que va con la cantidad (q piezas = plan q)
    planQ() { return this.pi != null ? this.pi + 1 : this.n; }
    nombre(n) {
      var c = this.d.cfg;
      if (c.modo === 'noches') return n + (n === 1 ? ' mes' : ' meses');
      if (c.modo === 'dias') return (n * c.dias) + ' días';
      return n + ' ' + (n === 1 ? c.u1 : c.un);
    }
    cantidad(n) {
      var c = this.d.cfg;
      if (c.modo === 'noches') return (n * c.dias) + ' noches';
      if (c.modo === 'dias') return n + ' ' + (n === 1 ? c.u1 : c.un);
      return '';
    }

    /* ---------- pintar ---------- */
    // Tarjeta 1 · 2 · 3 con la foto del producto repetida: 2 meses = 2 frascos.
    tarjeta(n) {
      var c = this.d.cfg, r = this.cuenta(n);
      var img = esc(String(this.d.main.img || '').replace(/width=\d+/, 'width=240')), pack = '';
      for (var i = 0; i < n; i++) pack += '<img src="' + img + '" alt="" width="64" height="64">';
      var env = r.envio ? '+ ' + m(r.envio) + ' de envío' : '<b class="gw-sel__verde">Envío gratis</b>';
      return '<button type="button" class="gw-sel__tile" role="radio" aria-checked="' + (n === this.n) + '" data-n="' + n + '">' + RADIO +
        // Leo, 12-oct: la de 3 dice el 5 % (el que cobra el descuento automático), no solo «Mejor precio»
        (n === 3 && (Number(c.pct3) > 0 || c.badge3) ? '<span class="gw-sel__badge">' + esc(Number(c.pct3) > 0 ? 'Ahorra ' + c.pct3 + ' %' : c.badge3) + '</span>' : '') +
        (img ? '<span class="gw-sel__pack gw-sel__pack--' + n + '" aria-hidden="true">' + pack + '</span>' : '') +
        '<span class="gw-sel__tn">' + esc(this.nombre(n)) + '</span>' +
        (this.cantidad(n) ? '<span class="gw-sel__td">' + esc(this.cantidad(n)) + '</span>' : '') +
        '<span class="gw-sel__tp"><b>' + m(r.precio) + '</b>' + (r.precio < r.base - 50 ? '<s>' + m(r.base) + '</s>' : '') + '</span>' +
        '<span class="gw-sel__te">' + env + '</span></button>';
    }
    // Complemento con su propia cantidad (Leo, 12-oct: «que ellos puedan elegir la cantidad»).
    renglonComp(i) {
      var x = this.comp[i], p = x.prod, on = x.m > 0, nom = esc(nomC(p));
      return '<div class="gw-sel__comp' + (on ? ' is-on' : '') + '">' +
        '<img class="gw-sel__kimg" src="' + esc(p.img) + '" alt="" width="44" height="44">' +
        '<span class="gw-sel__ot"><span class="gw-sel__on">' + nom + '</span>' +
        '<span class="gw-sel__od">' + (on ? '<b>' + m(x.m * p.p) + '</b>' : '+ ' + m(p.p)) + '</span></span>' + // un renglón: «Súmale…» ya dice que llega junto
        (on
          ? '<span class="gw-sel__step"><button type="button" data-c="' + i + '" data-d="-1" aria-label="Quitar un ' + nom + '">−</button>' +
            '<span aria-live="polite">' + x.m + '</span>' +
            '<button type="button" data-c="' + i + '" data-d="1" aria-label="Agregar otro ' + nom + '">+</button></span>'
          : '<button type="button" class="gw-sel__add" data-c="' + i + '" data-d="1" aria-label="Agregar ' + nom + '">Agregar</button>') +
        '</div>';
    }

    pintar() {
      var self = this, d = this.d, c = d.cfg, main = d.main, n = this.n;
      var o = this.pedido(), planSub = main.plan;
      if (!planSub) this.sub = false;
      var hayComp = this.comp.some(function (x) { return x.m > 0; });
      var total = this.sub && planSub ? o.precio * (1 - planSub.pct / 100) : o.precio;

      var html = c.cantidades === false ? '' : '<div class="gw-sel__tiles">' + [1, 2, 3].map(function (x) { return self.tarjeta(x); }).join('') + '</div>';
      var ch = '';
      if (this.comp.length) {
        ch += '<p class="gw-sel__grupo">' + esc(c.tCombina) + '</p>';
        // Roberto, 19-oct: el 5 % lo cobra el descuento automático desde 3 piezas
        if (c.tCombinaNota) ch += '<p class="gw-sel__nota">' + esc(c.tCombinaNota) + '</p>';
        this.comp.forEach(function (x, i) { if (i < 3 || x.m > 0) ch += self.renglonComp(i); });
        if (this.dlg) ch += '<button type="button" class="gw-sel__mas" data-dlg-abrir aria-haspopup="dialog">' + esc(c.tMas) + '</button>';
      }
      // Leo, 15-oct: los complementos debajo del botón (las decisiones de compra quedan arriba); «arriba» = como antes
      var compsAbajo = this.compsSlot || this.querySelector('.gw-sel__comps');
      if (compsAbajo && c.compsPos !== 'arriba') { compsAbajo.innerHTML = ch; } else { html += ch; }
      this.querySelector('.gw-sel__ops').innerHTML = html;
      if (this.dlg) {
        var dh = '<div class="gw-sel__dlg-in"><div class="gw-sel__dlg-top"><p class="gw-sel__grupo">Otros suplementos</p>' +
          '<button type="button" class="gw-sel__dlg-x" data-dlg-cerrar aria-label="Cerrar">×</button></div>';
        this.comp.forEach(function (x, i) { if (i >= 3) dh += self.renglonComp(i); });
        dh += '<button type="button" class="button button--primary gw-sel__dlg-ok" data-dlg-cerrar>Listo · ' + m(total) + '</button></div>';
        this.dlg.innerHTML = dh;
      }

      // Empujón: una sola línea, la que toca según lo elegido
      var cond = c.condCorta ? ' (' + c.condCorta + ')' : '', nh = '', ok = false;
      if (hayComp) {
        var ahorro = o.base - o.precio;
        if (ahorro >= 100) { nh = '<span>Juntos ahorras ' + m(ahorro) + (o.envio ? '' : ' y el envío es gratis') + '.</span>'; ok = true; }
      } else if (n === 1 && o.envio > 0) {
        var ci = -1;
        if (c.sugerir === 'kit') this.comp.some(function (x, i) { if (x.kit) { ci = i; return true; } return false; });
        var dif, que;
        if (ci >= 0) {
          this.comp[ci].m = 1; var o2 = this.pedido(); this.comp[ci].m = 0;
          dif = o2.precio + o2.envio - (o.precio + o.envio); que = corto(this.comp[ci].prod.t);
        } else {
          var r2 = this.cuenta(2); dif = r2.precio + r2.envio - (o.precio + o.envio); que = String(c.otra || '').toLowerCase();
        }
        if (dif > 0) nh = '<span>Por ' + m(dif) + ' más te llevas ' + esc(que) + ' y el envío gratis.</span>' +
          (ci >= 0 ? '<button type="button" data-c="' + ci + '" data-d="1">Agregar ' + esc(que) + '</button>' : '<button type="button" data-n="2">' + esc(c.otraBtn) + '</button>');
      } else if (n === 2 && c.modo !== 'piezas') {
        var r3 = this.cuenta(3), n3 = this.nombre(3);
        nh = '<span>Con ' + esc(n3) + (r3.base - r3.precio >= 100 ? ' ahorras ' + resta(r3.base, r3.precio) + ' y' : '') + ' te alcanza hasta el ' + hasta(3 * c.dias) + esc(cond) + '.</span><button type="button" data-n="3">Llevar ' + esc(n3) + '</button>';
      } else if (n === 3 && c.modo !== 'piezas') {
        nh = '<span>Te alcanza hasta el ' + hasta(3 * c.dias) + esc(cond) + ', sin resurtir.</span>';
        ok = true;
      }
      var nudge = this.querySelector('.gw-sel__nudge');
      nudge.innerHTML = nh;
      nudge.hidden = !nh;
      nudge.classList.toggle('is-ok', ok);

      // Compra única o suscripción, una junto a la otra, con las razones a la vista
      var compra = this.querySelector('.gw-sel__compra');
      compra.hidden = !planSub;
      if (planSub) {
        var q = this.planQ(), rs = o.precio * (1 - planSub.pct / 100), dias = cadaDias(planDe(main, q));
        var razones = String(c.subRazones || '').split(/\n+/).map(function (t) { return t.trim(); }).filter(Boolean).map(function (t) {
          return '<span>' + esc(t.replace('[pct]', planSub.pct).replace('[dias]', dias)) + '</span>';
        }).join('');
        compra.innerHTML = '<p class="gw-sel__grupo">' + esc(c.tCompra) + '</p>' +
          '<button type="button" class="gw-sel__op" role="radio" aria-checked="' + !this.sub + '" data-sub="0">' + RADIO +
            '<span class="gw-sel__ot"><span class="gw-sel__on">' + esc(c.tUnica) + '</span></span>' +
            '<span class="gw-sel__op-p"><b>' + m(o.precio) + '</b></span></button>' +
          '<button type="button" class="gw-sel__op gw-sel__op--sub" role="radio" aria-checked="' + this.sub + '" data-sub="1">' + RADIO +
            '<span class="gw-sel__ot"><span class="gw-sel__on">' + esc(String(c.subTxt || '').replace('[pct]', planSub.pct)) + '</span>' +
            '<span class="gw-sel__od"><b class="gw-sel__verde">Ahorras ' + resta(o.precio, rs) + ' en este pedido</b></span></span>' +
            '<span class="gw-sel__op-p"><b>' + m(rs) + '</b><s>' + m(o.precio) + '</s></span>' +
            (razones ? '<span class="gw-sel__razones">' + razones + '</span>' : '') + '</button>' +
          // Roberto, 19-oct: que se vea y se pueda elegir cada cuántos días llega (marcado: el que va con la cantidad)
          (this.sub && (planSub.ns || []).length > 1 ? '<div class="gw-sel__freq" role="radiogroup" aria-label="Llega cada"><span>Llega cada</span>' +
            planSub.ns.map(function (nm, i) {
              return '<button type="button" role="radio" aria-checked="' + (i === Math.min(q, planSub.ns.length) - 1) + '" data-f="' + i + '">' + RADIO + '<span>' + esc(cadaDias({ n: nm }) + ' días') + '</span></button>';
            }).join('') + '</div>' : '');
      }

      var extras = this.comp.filter(function (x) { return x.m > 0; }).map(function (x) { return nomC(x.prod) + (x.m > 1 ? ' × ' + x.m : ''); });
      var ctaB = this.querySelector('.gw-sel__cta');
      ctaB.disabled = !main.ok;
      ctaB.querySelector('span').textContent = main.ok ? (this.sub ? c.ctaSub : c.cta) + ' · ' + m(total) : 'Agotado';
      if (this.fija) {
        this.fija.querySelector('b').textContent = (c.cantidades === false ? '' : this.nombre(n) + ' de ') + corto(main.t) + (extras.length ? ' + ' + extras.join(' + ') : '');
        this.fija.querySelector('.gw-sel-fija__i span').textContent = m(total) + ' MXN';
      }
    }

    onClick(e) {
      if (e.target.closest('[data-dlg-abrir]')) { this.dlg.showModal(); return; }
      if (e.target.closest('[data-dlg-cerrar]')) { this.dlg.close(); return; }
      var enDlg = !!(this.dlg && this.dlg.contains(e.target));
      var enSlot = !!(this.compsSlot && this.compsSlot.contains(e.target));
      var b = e.target.closest('[data-n], [data-c], [data-sub], [data-f]');
      if (b) {
        var foco;
        if (b.dataset.f != null) { this.pi = Number(b.dataset.f); foco = '[data-f="' + this.pi + '"]'; }
        else if (b.dataset.n != null) { this.n = Number(b.dataset.n); this.pi = null; foco = '[data-n="' + this.n + '"]'; }
        else if (b.dataset.c != null) {
          var x = this.comp[Number(b.dataset.c)];
          x.m = Math.max(0, Math.min(9, x.m + Number(b.dataset.d)));
          foco = '[data-c="' + b.dataset.c + '"][data-d="' + (x.m ? b.dataset.d : 1) + '"]';
        } else { this.sub = b.dataset.sub === '1'; foco = '[data-sub="' + (this.sub ? 1 : 0) + '"]'; }
        this.pintar();
        // todo se volvió a dibujar: el foco regresa a lo que se tocó (teclado y lector de pantalla)
        var nuevo = (enDlg ? this.dlg : enSlot ? this.compsSlot : this).querySelector(foco); // la ventana y el bloque de complementos viven fuera
        if (nuevo) nuevo.focus({ preventScroll: true });
        return;
      }
      if (e.target.closest('.gw-sel__cta')) this.agregar();
    }

    agregar() {
      var c = this.d.cfg, q = this.planQ(), sub = this.sub && this.d.main.plan, o = this.pedido();
      // Con suscripción, todo llega con la frecuencia de lo elegido (2 meses → cada 60 días).
      var items = o.lineas.map(function (l) {
        var it = { id: l.prod.v, quantity: l.q };
        if (c.origen) it.properties = { _origen: c.origen };
        var pl = sub ? planDe(l.prod, q) : null;
        if (pl) it.selling_plan = pl.id;
        return it;
      });
      var botones = [this.querySelector('.gw-sel__cta')].concat(this.fija ? [this.fija.querySelector('[data-gw-add]')] : []);
      var err = this.querySelector('.gw-sel__error');
      err.textContent = '';
      botones.forEach(function (x) { x.disabled = true; x.setAttribute('aria-busy', 'true'); });
      var drawer = document.querySelector('cart-drawer'), body = { items: items };
      if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
      fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (res) { return res.json().then(function (data) { if (!res.ok || data.status) throw new Error(data.description || data.message || ''); return data; }); })
        .then(function (data) {
          if (drawer && data.sections) {
            drawer.classList.remove('is-empty'); // como product-form.js: si no, el cajón abre vacío
            drawer.renderContents(data);
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gw-selector', cartData: data });
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function (e2) { err.textContent = (e2 && e2.message) || 'No se pudo agregar. Intenta de nuevo.'; })
        .finally(function () { botones.forEach(function (x) { x.disabled = false; x.removeAttribute('aria-busy'); }); });
    }

    // Barra fija: aparece cuando el botón ya quedó arriba de la pantalla.
    observar() {
      if (!this.fija || !('IntersectionObserver' in window)) return;
      var fija = this.fija;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var on = !en.isIntersecting && en.boundingClientRect.top < 0;
          fija.classList.toggle('is-on', on);
          fija.setAttribute('aria-hidden', String(!on));
          fija.querySelector('[data-gw-add]').tabIndex = on ? 0 : -1;
          document.documentElement.classList.toggle('gw-sel-fija-on', on);
        });
      }).observe(this.querySelector('.gw-sel__cta'));
    }
  }
  window.customElements.define('gw-selector', GwSelector);
})();
